<template>
  <div>
    <div class="container page-body">
      <!-- <h2>Images List Pending</h2>
      <div v-for="image in imagesList('Pending')" :key="image.id">
        {{ image.breed }} {{ image.caption }}
      </div> -->

      <div class="general-panel">
        <div class="general-panel__header general-panel--blue">
          <h5 class="general-panel__header-text">
            <i class="general-panel__header-icon fas fa-check-square"></i>
            Selected: {{ numberImages }}
          </h5>
        </div>

        <ToggleControl
          toggle-id="list-desc"
          closed-text="About this list"
          open-text="- hide -"
          toggle-class="general-panel__toggle-pane general-panel--blue"
        >
          <template v-slot:default="slotProps">
            {{ slotProps.togglerText.display }}
          </template>
        </ToggleControl>

        <div class="general-panel__content">
          <b-collapse id="list-desc">
            <div class="general-panel__row general-panel__row--standard-text">
              <p class="font-weight-bold mb-1">Selected List Overview</p>
              <p>
                This list shows your images that have been selected by us for
                inclusion in a calendar or book project!
              </p>
              <p>
                The number in the blue button above and in the header of this
                text block is how many images are in this list:
                <strong>{{ numberImages }}</strong>
              </p>
              <p>
                An image in this list <span class="italic">was</span> in your
                <strong>Uploads</strong> list; it no longer appears there
                (freeing up an Upload Slot for you).
              </p>
              <p>
                When we start a new book or calendar project, we look in the
                <strong>Uploads</strong> list of our users. In general, we
                select 40 - 60 images for each project, selecting one (1) image
                each from as many users.
              </p>
              <p class="font-weight-bold mb-1">Editing/Deleting Images</p>
              <p>
                Images in this list <strong>cannot</strong> be edited or deleted
                - only images in your <strong>Uploads</strong> list can be
                edited or deleted.
              </p>
              <p>
                Why? Because at this stage, the image and its associated text
                are "finalized" since the project is in production at this point
                and accepting changes could possibly disrupt our production
                process too much.
              </p>
              <p class="font-weight-bold mb-1">Discovering Typos, etc.</p>
              <p>
                That said, as we're working with a given image, processing it
                for placement in a book or calendar, if we have any questions
                about your information - for example, we encounter a word or
                name that we think <span class="italic">might</span> be
                misspelled - we will contact you via email to ask for
                clarification and/or confirmation about the possible error.
              </p>
              <p>
                On the other hand, as <strong>you</strong> look at your list of
                <strong>Selected</strong> images, what if
                <span class="italic">you</span> discover a misspelling or other
                wrong information? For example, your dog's name has a typo, or
                any other problems with your text entries. In that case, you can
                contact us and let us know. If you reach us early enough, we
                might be able to make the correction. But, if the project is
                completed and about to be published, it will be too late.
              </p>
              <p class="font-weight-bold mb-1">
                The Path of an Image Through These Lists
              </p>

              <p>
                When putting together a new project and we're looking for photos
                to include, sometimes we also look in the
                <strong>Published</strong> list of images of our users. That's
                how it's possible that a given image
                <span class="italics">can or may</span> appear in more than one
                book or calendar.
              </p>
              <p>
                ***When an already-published image is selected for
                <span class="italic">another</span> project, that image does
                <strong>not</strong> appear in this
                <strong>Selected</strong> list.
              </p>
              <p>
                In other words, when you upload an image, it potentially has
                just this one path through your lists: Uploads -> Selected ->
                Published.
              </p>
              <p class="italic">
                Note: The other path an image can take is: Uploads -> Unusable.
                That's for any image we deem unsuitable for publication (read
                more in the <strong>Unusable</strong> List overview by clicking
                the red button above labeled Unusable).
              </p>
            </div>
          </b-collapse>
          <div
            v-if="numberImages > 0"
            class="general-panel__row general-panel__row--3col"
          >
            <!-- <transition-group> -->
            <div>
              <!-- need div since css grid defined on this element ... per <transitiion-group> in ImagesListPending component -->
              <CardImage
                v-for="image in images"
                :key="image.id"
                :image="image"
                :type="type"
                :showHeader="showHeader"
                :showButtonPanel="showButtonPanel"
                :showProductsPanel="showProductsPanel"
              />
            </div>
            <!-- </transition-group> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ToggleControl from '@/components/layout/ToggleControl';
import CardImage from '@/components/cards/CardImage';
import { mapGetters } from 'vuex';

function sortByCreateTime(dataArray, sortOrder) {
  // If sortOrder is NOT des, set it to empty str (which will be set to default value of 'asc' in following line).
  // With these two lines, we force sortOrder to be one of 'asc' or 'des' no matter what the function is called with.
  sortOrder = sortOrder !== 'des' ? '' : sortOrder;
  sortOrder = sortOrder || 'asc';

  const sortFunction =
    sortOrder === 'asc'
      ? (a, b) => a.creTime - b.creTime
      : (a, b) => b.creTime - a.creTime;
  dataArray.sort(sortFunction);
  return dataArray;
}

export default {
  name: 'ImagesListSelected',
  components: {
    ToggleControl,
    CardImage,
  },
  data: function () {
    return {
      componentKey: 1,
      type: 'selected',
      showHeader: true,
      showButtonPanel: false,
      showProductsPanel: false,
      images: [],
    };
  },
  watch: {
    // If the number of images in this view, e.g. 'pending' images, changes (e.g. one gets put in the 'selected' bin),
    // re-render the view to reflect this.
    numberImages: function () {
      this.rerenderView();
    },
  },
  computed: {
    ...mapGetters('uploadTracker', ['imagesList']),

    numberImages: function () {
      // var submittedAndPending = [];
      // var submitted = this.imagesList('Submitted');
      // var pending = this.imagesList('Pending');
      // if (submitted && pending) {
      //   submittedAndPending = [...submitted, ...pending];
      //   // submitted.forEach((i) => submittedAndPending.push(i));
      //   // pending.forEach((i) => submittedAndPending.push(i));
      // }
      // return submittedAndPending.length;

      return this.imagesList('Selected').length;
    },
  },
  methods: {
    rerenderView: function () {
      this.$parent.rerenderView();
    },
  },
  created: function () {
    var selected = this.imagesList('Selected');

    // If this route is current route, hitting browser refresh might have the two arrays NOT set yet
    if (selected) {
      this.images = sortByCreateTime(selected, 'des');
    }

    var imageNum = 1;
    this.images.forEach((image) => {
      image.imageNum = imageNum;
      imageNum++;
    });
  },
};
</script>

<style>
</style>